<template>
	<div style="height: 80vh; width: 100%;">
		<Dialog :header="$t('Welcome')" :visible.sync="displayFirstAccessDialog" :style="{width: '95%', height: '40%'}" :contentStyle="{height: '100%'}">
			<p>Stai per iniziare una trattativa ufficiale sulla <i>transfer platform</i> di <strong>TiroLibre</strong>. Le tue conversazioni e i messaggi rimangono tra te e i tuoi interlocutori.</p>
			<p>Se necessario, un referente di TiroLibre supporterà e farà da mediatore.</p>
		</Dialog>

		<iframe :src="chatLoginUrl" id="whatchat" scrolling="no" frameborder="0" style="position: relative; height: 100%; width: 100%;">
		</iframe>
	</div>
</template>

<script>
import AuthService from "@/service/AuthService";
import Vue from "vue";

export default {
	components: {},
	data() {
		return {
			email: null,
			baseUserId: null,
			role: null,
			chatLoginUrl: null,
			displayFirstAccessDialog: true,
		};
	},
	authService: null,
	created() {
        // show dialog or not
		let chatFirstAccess = localStorage.getItem("chatAccess");
		if (chatFirstAccess == 1) this.displayFirstAccessDialog = false;
		else localStorage.setItem("chatAccess", 1);

		this.authService = new AuthService();

		this.email = this.authService.getUserEmail();
		this.role = this.authService.getUserRole();
		this.passwordHash = this.authService.getpasswordHash();

		this.chatLoginUrl =
			Vue.prototype.$whatchat +
			"/#/login?email=" +
			encodeURIComponent(this.email) +
			"&" +
			"password=" +
			encodeURIComponent(this.passwordHash);
	},
};
</script>